import Swiper from 'swiper';
import { Autoplay, FreeMode } from 'swiper/modules';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {

    const swiperEl = document.querySelector('.header__swiper');
    if (!swiperEl) return;

    const isMobile = window.matchMedia('(max-width: 425px)').matches;

    const slides = swiperEl.querySelectorAll('.swiper-slide');

    if (isMobile && slides.length === 1) {
        const wrapper = swiperEl.querySelector('.swiper-wrapper');
        wrapper.appendChild(slides[0].cloneNode(true));
    }

    const finalSlides = swiperEl.querySelectorAll('.swiper-slide');

    if (isMobile) {

        new Swiper('.header__swiper', {
            modules: [Autoplay, FreeMode],

            loop: true,
            slidesPerView: 'auto',

            freeMode: true,
            freeModeMomentum: false,

            speed: 8000,

            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
        });

    }

});